require('./transitions.less');

module.exports = {
    panel: "panel panel-default",
    panelTitle: 'panel-title clearfix',
    panelHeading: 'panel-heading',
    panelBody: "panel-body",
    group: "form-group",
}


/** WEBPACK FOOTER **
 ** ./src/styles/CollectionCreateTemplate-style.js
 **/